
import { getLatestFileUpload } from "@/api/declinedTransactions/api";
import { formatDate } from "@/helpers/date";
import Vue from "vue";

/**
 * The length of time (In ms) to wait before refreshing the data
 */
const REFRESH_DATA_INTERVAL_MS = 30000;

/**
 * The length of time (In ms) to wait before retriyng after a failed request
 */
const RETRY_DATA_INTERVAL_MS = 500;

export default Vue.extend({
  data() {
    return {
      hasLoaded: false,
      isLoading: false,
      lastFileDate: "",
      lastFileRecievedDate: "",
      lastFileName: "",
      lastFileRecordCount: 0,
      timeout: null,
    };
  },
  computed: {},
  methods: {
    /*
        Regularly refreshes the data to keep the screen up to date
    */
    async refresh_data() {
      this.isLoading = true;
      try {
        const data = await getLatestFileUpload();

        this.lastFileDate = formatDate(
          new Date(data.fileCreationDateTime),
          "dd/MM/yyyy hh:mm aa"
        );

        this.lastFileRecievedDate = formatDate(
          new Date(data.fileRecievedDateTime),
          "dd/MM/yyyy hh:mm aa"
        );
        this.lastFileName = data.fileName;
        this.lastFileRecordCount = data.fileRecordCount;
        this.hasLoaded = true;
        this.isLoading = false;
        this.timeout = setTimeout(this.refresh_data, REFRESH_DATA_INTERVAL_MS);
      } catch {
        this.timeout = setTimeout(this.refresh_data, RETRY_DATA_INTERVAL_MS);
      }
    },
  },
  async mounted() {
    this.refresh_data();
  },
  /**
   * Don't want to keep updating the data if the screen is closed
   */
  destroyed() {
    clearTimeout(this.timeout);
  },
});
